import {
    // FILE_UPLOAD,
    CREATE_SJFSECTORS,
    RETRIEVE_SJFSECTORS,
    UPDATE_SJFSECTORS,
    DELETE_SJFSECTORS,
    RETRIEVESINGLE_SJFSECTORS,
} from "./type";
import SJFSectors from "../service/sjfSectors";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await SJFSectors.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await SJFSectors.create(data);
        dispatch({
            type: CREATE_SJFSECTORS,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await SJFSectors.fetchList(data);
        dispatch({
            type: RETRIEVE_SJFSECTORS,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await SJFSectors.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_SJFSECTORS,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await SJFSectors.update(data);
        dispatch({
            type: UPDATE_SJFSECTORS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await SJFSectors.changeStatus(data);
//         dispatch({
//             type: UPDATE_SJFSECTORS,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await SJFSectors.trash(data);
        dispatch({
            type: DELETE_SJFSECTORS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};